import { useQuery } from '@tanstack/react-query';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useGetGroupSharedFiles(groupId?: number, enabled: boolean = true) {
  return useQuery({
    queryKey: [GroupKey.GROUP_SHARED_FILES, groupId],
    queryFn: () => GroupService.getGroupSharedFiles(groupId).then((response) => response.data),
    enabled: enabled && groupId !== undefined,
  });
}
